import { context } from '@shared-services/context-service';
import { logger } from '@shared-services/log-service';

export const logBookingError = (
    message: string,
    additionalInfoToLog: Record<string, unknown>
) => {
    logger.error({
        message,
        tags: ['__new-runtime__', 'RuntimeCalBooking'],
        isEditor: context.isEditor,
        ...additionalInfoToLog,
    });
};
